import React, { ChangeEvent, FormEvent, useEffect, useState } from 'react';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import Login from './Login';
import { FaChevronRight, FaDoorOpen, FaMinus, FaPlus } from 'react-icons/fa6';
import { Accordion, AccordionItem, Alert, Button, Input, Textarea, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, useDisclosure, Select, SelectItem } from '@nextui-org/react';
import Cookies from 'cookies-js';
import axios from 'axios';
import * as api from "../services/api";
import { AlertDialog } from '@radix-ui/themes';
import Departments from '../components/Departments';
import Service from '../components/Service';
import ServiceGroups from '../components/ServiceGroups';
import Services from '../components/Services';
import { FaEdit, FaTrash } from 'react-icons/fa';
import {
    Table,
    TableHeader,
    TableColumn,
    TableBody,
    TableRow,
    TableCell
} from '@nextui-org/react';

interface Department {
    id: number;
    title: string;
    description: string;
    doctor_id: number;
    price: number;
}

interface ServiceType {
    id: number;
    title: string;
    price: number;
    count: number;
}

interface ServiceGroup {
    id: number;
    title: string;
    service_ids: number[];
}

export interface DepartmentDTO {
    doctor_id: number;
    price: number;
    title: string;
    description: string;
}

const AdminPanel = () => {
    const auth = Boolean(Cookies.get('hasPermit')) || false;
    const location = useLocation();
    const navigate = useNavigate();
    const [images, setImages] = useState<string[]>(['']);
    const [departments, setDepartments] = useState<Department[]>([]);
    const [websiteContent, setWebsiteContent] = useState({
        banner_title: '',
        banner_descr: '',
        about_us_descr: '',
        phone_number: '',
        email: '',
    });
    const { isOpen, onClose, onOpenChange } = useDisclosure();
    const [departmentFormData, setDepartmentFormData] = useState<DepartmentDTO>({
        title: '',
        description: '',
        doctor_id: 0,
        price: 0,
    });
    const [doctors, setDoctors] = useState<any>([]);
    const [selectedDoctor, setSelectedDoctor] = useState<any>();
    const [service, setService] = useState<ServiceType[]>([]);
    const [services, setServices] = useState<ServiceType[]>([]);
    const [serviceGroups, setServiceGroups] = useState<ServiceGroup[]>([]);

    const [newService, setNewService] = useState({ title: '', price: 0, count: 0 });

    const [newGroupTitle, setNewGroupTitle] = useState('');
    const [selectedServiceIds, setSelectedServiceIds] = useState<number[]>([]);

    const [editingService, setEditingService] = useState<ServiceType | null>(null);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);

    const [editingServiceGroup, setEditingServiceGroup] = useState<ServiceGroup | null>(null);
    const [isEditGroupModalOpen, setIsEditGroupModalOpen] = useState(false);
    const [editGroupTitle, setEditGroupTitle] = useState('');
    const [editGroupServiceIds, setEditGroupServiceIds] = useState<number[]>([]);

    const [editingDoctor, setEditingDoctor] = useState<any>(null);
    const [isEditDoctorModalOpen, setIsEditDoctorModalOpen] = useState(false);

    const openEditDoctorModal = (doctor: any) => {
        setEditingDoctor(doctor);
        setIsEditDoctorModalOpen(true);
    };

    const handleEditDoctor = async () => {
        if (!editingDoctor) return;

        try {
            await axios.put(`https://api.tashirmc.am/doctors/update/${editingDoctor.id}`, editingDoctor);
            fetchDoctors();
            setIsEditDoctorModalOpen(false);
            setEditingDoctor(null);
        } catch (e) {
            console.error("Ошибка при обновлении врача", e);
        }
    };

    const handleEditDoctorChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        if (editingDoctor) {
            setEditingDoctor({
                ...editingDoctor,
                [name]: value
            });
        }
    };

    const fetchServices = async () => {
        try {
            const res = await axios.get("https://api.tashirmc.am/service/findAll");
            setServices(res.data);
        } catch (e) {
            console.error("Ошибка загрузки сервисов", e);
        }
    };

    const fetchServiceGroups = async () => {
        try {
            const res = await axios.get("https://api.tashirmc.am/services/findAll");
            setServiceGroups(res.data);
        } catch (e) {
            console.error("Ошибка загрузки групп сервисов", e);
        }
    };

    useEffect(() => {
        fetchServices();
        fetchServiceGroups();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            const response = await axios.get("https://api.tashirmc.am/service/findAll")
            setService(response.data)
        }
        fetchData()
    }, [])

    const [doctorForm, setDoctorForm] = useState({
        first_name: "",
        last_name: "",
        father_name: "",
        phone_number: 0,
        profile_picture: ""
    })

    const createDepartment = async () => {
        try {
            const response = await axios.post("https:///api.tashirmc.am/departments/create", departmentFormData);
            console.log('Department created:', response.status);
            return response.data;
        } catch (error) {
            console.error('Error creating department:', error);
            throw error;
        }
    };

    const deleteDoctor = async (id: number) => {
        const response = await axios.delete(`https://api.tashirmc.am/doctors/delete/${id}`);
        console.log(response.data);
        fetchDoctors()
    }

    const fetchDoctors = async () => {
        const response = await axios.get("https://api.tashirmc.am/doctors/findAll");
        setDoctors(response.data)
    }

    const handleAddDoctor = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        await axios.post("https://api.tashirmc.am/doctors/create", doctorForm);
        setDoctorForm({
            first_name: "",
            last_name: "",
            father_name: "",
            profile_picture: "",
            phone_number: 0
        })
        await fetchDoctors();
    }

    useEffect(() => {
        if (auth) {
            fetchWebsiteContent();
            fetchDoctors();
        }
    }, [auth]);

    const fetchWebsiteContent = async () => {
        try {
            const data = await api.fetchWebsiteContent();
            setWebsiteContent(data[0]);
        } catch (error) {
            console.error('Failed to fetch departments:', error);
        }
    };

    const handleWebsiteContentUpdate = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            await axios.put('https://api.tashirmc.am/website-content/update/1', websiteContent);
            alert('Website content updated successfully!');
        } catch (error) {
            console.error('Failed to update website content:', error);
        }
    };

    const handleDepartmentFormChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setDepartmentFormData((prev) => ({ ...prev, doctor_id: selectedDoctor }))
        setDepartmentFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleAddDepartment = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            createDepartment()
            onClose();
        } catch (error) {
            console.error('Failed to add department:', error);
        }
    };

    const handleChangeDoctor = (e: ChangeEvent<HTMLInputElement>) => {
        const { value, name } = e.target;
        setDoctorForm((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const handleAddImage = () => {
        setImages((prev) => [...prev, '']);
    };

    const handleRemoveImage = (index: number) => {
        setImages((prev) => prev.filter((_, i) => i !== index));
    };

    const handleLogout = () => {
        Cookies.set('hasPermit', '');
        navigate('/adm.pnl');
    };

    if (!auth) {
        return <Login />;
    }

    const queryParams = new URLSearchParams(location.search);
    const page = queryParams.get('route');

    if (page !== '/home/site-managemant' && auth) {
        return <Navigate to="/adm.pnl?route=/home/site-managemant" />;
    }

    const createService = async () => {
        try {
            await axios.post("https://api.tashirmc.am/service/create", newService);
            setNewService({ title: '', price: 0, count: 0 });
            fetchServices();
        } catch (e) {
            console.error("Ошибка создания сервиса", e);
        }
    };

    const deleteService = async (id: number) => {
        try {
            await axios.delete(`https://api.tashirmc.am/service/delete/${id}`);
            fetchServices();
        } catch (e) {
            console.error("Ошибка при удалении сервиса", e);
        }
    };

    const openEditModal = (service: ServiceType) => {
        setEditingService(service);
        setIsEditModalOpen(true);
    };

    const handleEditService = async () => {
        if (!editingService) return;

        try {
            await axios.put(`https://api.tashirmc.am/service/update/${editingService.id}`, editingService);
            fetchServices();
            setIsEditModalOpen(false);
            setEditingService(null);
        } catch (e) {
            console.error("Ошибка при обновлении сервиса", e);
        }
    };

    const handleEditServiceChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        if (editingService) {
            setEditingService({
                ...editingService,
                [name]: name === 'title' ? value : Number(value)
            });
        }
    };

    // Функции для работы с группами сервисов
    const createServiceGroup = async () => {
        try {
            await axios.post("https://api.tashirmc.am/services/create", {
                title: newGroupTitle,
                service_ids: selectedServiceIds,
            });
            setNewGroupTitle('');
            setSelectedServiceIds([]);
            fetchServiceGroups();
        } catch (e) {
            console.error("Ошибка создания группы сервисов", e);
        }
    };

    const deleteServiceGroup = async (id: number) => {
        try {
            await axios.delete(`https://api.tashirmc.am/services/delete/${id}`);
            fetchServiceGroups();
        } catch (e) {
            console.error("Ошибка при удалении группы сервисов", e);
        }
    };

    const openEditGroupModal = (group: ServiceGroup) => {
        setEditingServiceGroup(group);
        setEditGroupTitle(group.title);
        setEditGroupServiceIds(group.service_ids);
        setIsEditGroupModalOpen(true);
    };

    const handleEditServiceGroup = async () => {
        if (!editingServiceGroup) return;

        try {
            await axios.put(`https://api.tashirmc.am/services/update/${editingServiceGroup.id}`, {
                title: editGroupTitle,
                service_ids: editGroupServiceIds
            });
            fetchServiceGroups();
            setIsEditGroupModalOpen(false);
            setEditingServiceGroup(null);
        } catch (e) {
            console.error("Ошибка при обновлении группы сервисов", e);
        }
    };

    const handleServiceGroupSelectionChange = (keys: any) => {
        const ids = Array.from(keys).map((k: any) => Number(k));
        setSelectedServiceIds(ids);
    };

    const handleEditGroupServiceSelectionChange = (keys: any) => {
        const ids = Array.from(keys).map((k: any) => Number(k));
        setEditGroupServiceIds(ids);
    };

    const handleNewServiceChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setNewService(prev => ({
            ...prev,
            [name]: name === 'title' ? value : Number(value)
        }));
    };

    return (
        <div className="max-w-[1200px] w-full mx-auto">
            <header className="bg-cyan-600 p-5 flex justify-between items-center">
                <div className="flex gap-1 text-white">
                    {page
                        ?.split('/')
                        .map((route, index) => (
                            <span key={index} className="flex gap-1 items-center">
                                {route.charAt(0).toUpperCase() + route.slice(1)}
                                {index < (page?.split('/').length || 0) - 1 && <FaChevronRight />}
                            </span>
                        ))}
                </div>
                <Button onClick={handleLogout} size={window.innerWidth > 700 ? 'lg' : 'md'} color="danger">
                    <FaDoorOpen /> Logout
                </Button>
            </header>

            <div className="p-5 flex gap-5 sm:gap-3 items-center justify-center">
                <Link className="flex-1 h-[40px]" to="/adm.pnl?route=/home/site-managemant">
                    <Button className="w-full" size={window.innerWidth > 700 ? 'lg' : 'md'} color={page === '/home/site-managemant' ? 'success' : 'warning'} variant="flat">
                        Site Management
                    </Button>
                </Link>
            </div>

            <section style={{ marginTop: 40, display: "flex", flexDirection: "column", gap: "10px", alignItems: "start" }}>
                <h2>Add new service</h2>
                <Input
                    label="Title"
                    name="title"
                    value={newService.title}
                    onChange={handleNewServiceChange}
                    style={{ marginBottom: 8 }}
                />
                <Input
                    label="Price"
                    name="price"
                    type="number"
                    value={newService.price.toString()}
                    onChange={handleNewServiceChange}
                    style={{ marginBottom: 8 }}
                />
                <Input
                    label="Count"
                    name="count"
                    type="number"
                    value={newService.count.toString()}
                    onChange={handleNewServiceChange}
                    style={{ marginBottom: 8 }}
                />
                <Button onClick={createService} color="primary" style={{ marginBottom: 20 }}>
                    Create service
                </Button>
            </section>

            <section style={{ marginTop: 40, display: "flex", flexDirection: "column", gap: "10px", alignItems: "start" }}>
                <h2>Add service group</h2>
                <Input
                    label="Group name"
                    value={newGroupTitle}
                    onChange={(e) => setNewGroupTitle(e.target.value)}
                    style={{ marginBottom: 8 }}
                />
                <Select
                    label="Select services"
                    selectionMode="multiple"
                    selectedKeys={new Set(selectedServiceIds.map(String))}
                    onSelectionChange={handleServiceGroupSelectionChange}
                    style={{ marginBottom: 20 }}
                >
                    {services.map((service: ServiceType) => (
                        <SelectItem key={service.id} value={service.id.toString()}>
                            {service.title} (цена: {service.price}, кол-во: {service.count})
                        </SelectItem>
                    ))}
                </Select>
                <Button onClick={createServiceGroup} color="primary">
                    Create service group
                </Button>
            </section>

            <section style={{ marginTop: 40 }}>
                <h2 className="text-2xl mb-4">Services list</h2>
                <Table aria-label="Список сервисов">
                    <TableHeader>
                        <TableColumn>Title</TableColumn>
                        <TableColumn>Price</TableColumn>
                        <TableColumn>Count</TableColumn>
                        <TableColumn>Action</TableColumn>
                    </TableHeader>
                    <TableBody>
                        {services.map((service) => (
                            <TableRow key={service.id}>
                                <TableCell>{service.title}</TableCell>
                                <TableCell>{service.price}</TableCell>
                                <TableCell>{service.count}</TableCell>
                                <TableCell>
                                    <div className="flex gap-2">
                                        <Button
                                            isIconOnly
                                            color="primary"
                                            onClick={() => openEditModal(service)}
                                        >
                                            <FaEdit />
                                        </Button>
                                        <Button
                                            isIconOnly
                                            color="danger"
                                            onClick={() => deleteService(service.id)}
                                        >
                                            <FaTrash />
                                        </Button>
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </section>
            <Modal isOpen={isEditModalOpen} onOpenChange={() => setIsEditModalOpen(!isEditModalOpen)}>
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalHeader>Редактировать сервис</ModalHeader>
                            <ModalBody>
                                {editingService && (
                                    <>
                                        <Input
                                            label="Название"
                                            name="title"
                                            value={editingService.title}
                                            onChange={handleEditServiceChange}
                                        />
                                        <Input
                                            label="Цена"
                                            name="price"
                                            type="number"
                                            value={editingService.price.toString()}
                                            onChange={handleEditServiceChange}
                                        />
                                        <Input
                                            label="Количество"
                                            name="count"
                                            type="number"
                                            value={editingService.count.toString()}
                                            onChange={handleEditServiceChange}
                                        />
                                    </>
                                )}
                            </ModalBody>
                            <ModalFooter>
                                <Button color="danger" variant="light" onPress={onClose}>
                                    Отмена
                                </Button>
                                <Button color="primary" onPress={handleEditService}>
                                    Сохранить
                                </Button>
                            </ModalFooter>
                        </>
                    )}
                </ModalContent>
            </Modal>

            <section style={{ marginTop: 40 }}>
                <h2 className="text-2xl mb-4">Service Groups</h2>
                <Table aria-label="Service groups list">
                    <TableHeader>
                        <TableColumn>Title</TableColumn>
                        <TableColumn>Services Count</TableColumn>
                        <TableColumn>Actions</TableColumn>
                    </TableHeader>
                    <TableBody>
                        {serviceGroups.map((group) => (
                            <TableRow key={group.id}>
                                <TableCell>{group.title}</TableCell>
                                <TableCell>{group.service_ids.length}</TableCell>
                                <TableCell>
                                    <div className="flex gap-2">
                                        <Button
                                            isIconOnly
                                            color="primary"
                                            onClick={() => openEditGroupModal(group)}
                                        >
                                            <FaEdit />
                                        </Button>
                                        <Button
                                            isIconOnly
                                            color="danger"
                                            onClick={() => deleteServiceGroup(group.id)}
                                        >
                                            <FaTrash />
                                        </Button>
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </section>

            {/* Модальное окно редактирования группы сервисов */}
            <Modal isOpen={isEditGroupModalOpen} onOpenChange={() => setIsEditGroupModalOpen(!isEditGroupModalOpen)}>
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalHeader>Edit Service Group</ModalHeader>
                            <ModalBody>
                                {editingServiceGroup && (
                                    <>
                                        <Input
                                            label="Group Title"
                                            value={editGroupTitle}
                                            onChange={(e) => setEditGroupTitle(e.target.value)}
                                        />
                                        <Select
                                            label="Select Services"
                                            selectionMode="multiple"
                                            selectedKeys={new Set(editGroupServiceIds.map(String))}
                                            onSelectionChange={handleEditGroupServiceSelectionChange}
                                            style={{ marginBottom: 20 }}
                                        >
                                            {services.map((service: ServiceType) => (
                                                <SelectItem key={service.id} value={service.id.toString()}>
                                                    {service.title} (price: {service.price}, count: {service.count})
                                                </SelectItem>
                                            ))}
                                        </Select>
                                    </>
                                )}
                            </ModalBody>
                            <ModalFooter>
                                <Button color="danger" variant="light" onPress={onClose}>
                                    Cancel
                                </Button>
                                <Button color="primary" onPress={handleEditServiceGroup}>
                                    Save
                                </Button>
                            </ModalFooter>
                        </>
                    )}
                </ModalContent>
            </Modal>

            <div className="p-5">
                {page === '/home/site-managemant' && (
                    <div className="mt-6 flex flex-col gap-10">
                        {/* Website Content Form */}
                        <form onSubmit={handleWebsiteContentUpdate} className="flex flex-col items-end gap-3">
                            <Textarea
                                name="banner_title"
                                value={websiteContent ? websiteContent.banner_title : "Fetching..."}
                                defaultValue={websiteContent ? websiteContent.banner_title : "Fetching..."}
                                onChange={(e) => setWebsiteContent({ ...websiteContent, banner_title: e.target.value })}
                                variant="underlined"
                                label="Banner Title"
                            />
                            <Button type="submit" color="success" variant="flat">
                                Save
                            </Button>
                        </form>

                        {/* About Us Section */}
                        <form onSubmit={handleWebsiteContentUpdate} className="flex flex-col items-end gap-3">
                            <Textarea
                                value={websiteContent ? websiteContent.about_us_descr : "Fetching..."}
                                onChange={(e) => setWebsiteContent({ ...websiteContent, about_us_descr: e.target.value })}
                                variant="flat"
                                label="About Us"
                            />
                            <Button type="submit" color="success" variant="flat">
                                Save
                            </Button>
                        </form>

                        <Departments doctors={doctors} />

                        {/* Services Section */}
                        <div>
                            <h2 className="text-2xl mt-6">Our Doctors</h2>
                            <form action="" className='flex w-full flex-col gap-2 items-end'>
                                <Table aria-label="Doctors list">
                                    <TableHeader>
                                        <TableColumn>#</TableColumn>
                                        <TableColumn>First Name</TableColumn>
                                        <TableColumn>Last Name</TableColumn>
                                        <TableColumn>Father Name</TableColumn>
                                        <TableColumn>Phone number</TableColumn>
                                        <TableColumn>Profile picture</TableColumn>
                                        <TableColumn>Actions</TableColumn>
                                    </TableHeader>
                                    <TableBody>
                                        {doctors && doctors.map((doctor: any) => (
                                            <TableRow key={doctor.id}>
                                                <TableCell>{doctor.id}</TableCell>
                                                <TableCell>{doctor.first_name}</TableCell>
                                                <TableCell>{doctor.last_name}</TableCell>
                                                <TableCell>{doctor.father_name}</TableCell>
                                                <TableCell>{doctor.phone_number}</TableCell>
                                                <TableCell>{doctor.profile_picture}</TableCell>
                                                <TableCell>
                                                    <div className='flex justify-end gap-4'>
                                                        <Button
                                                            isIconOnly
                                                            color="primary"
                                                            onClick={() => openEditDoctorModal(doctor)}
                                                        >
                                                            <FaEdit />
                                                        </Button>
                                                        <Button
                                                            onClick={() => deleteDoctor(doctor.id)}
                                                            color='danger'
                                                        >
                                                            Delete
                                                        </Button>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>

                                {/* Модальное окно редактирования врача */}
                                <Modal isOpen={isEditDoctorModalOpen} onOpenChange={() => setIsEditDoctorModalOpen(!isEditDoctorModalOpen)}>
                                    <ModalContent>
                                        {(onClose) => (
                                            <>
                                                <ModalHeader>Edit Doctor</ModalHeader>
                                                <ModalBody>
                                                    {editingDoctor && (
                                                        <>
                                                            <Input
                                                                label="First Name"
                                                                name="first_name"
                                                                value={editingDoctor.first_name}
                                                                onChange={handleEditDoctorChange}
                                                            />
                                                            <Input
                                                                label="Last Name"
                                                                name="last_name"
                                                                value={editingDoctor.last_name}
                                                                onChange={handleEditDoctorChange}
                                                            />
                                                            <Input
                                                                label="Father Name"
                                                                name="father_name"
                                                                value={editingDoctor.father_name}
                                                                onChange={handleEditDoctorChange}
                                                            />
                                                            <Input
                                                                label="Phone Number"
                                                                name="phone_number"
                                                                value={editingDoctor.phone_number}
                                                                onChange={handleEditDoctorChange}
                                                            />
                                                            <Input
                                                                label="Profile Picture"
                                                                name="profile_picture"
                                                                value={editingDoctor.profile_picture}
                                                                onChange={handleEditDoctorChange}
                                                            />
                                                        </>
                                                    )}
                                                </ModalBody>
                                                <ModalFooter>
                                                    <Button color="danger" variant="light" onPress={onClose}>
                                                        Cancel
                                                    </Button>
                                                    <Button color="primary" onPress={handleEditDoctor}>
                                                        Save
                                                    </Button>
                                                </ModalFooter>
                                            </>
                                        )}
                                    </ModalContent>
                                </Modal>

                                <AlertDialog.Root>
                                    <AlertDialog.Trigger>
                                        <Button color='success' variant='flat'>Add new doctor</Button>
                                    </AlertDialog.Trigger>
                                    <AlertDialog.Content size={"3"}>
                                        <AlertDialog.Title>Add new doctor</AlertDialog.Title>
                                        <form action="" onSubmit={handleAddDoctor} className='flex flex-col gap-3'>
                                            <Input value={doctorForm.first_name} onChange={handleChangeDoctor} name='first_name' variant='underlined' label='First Name' />
                                            <Input value={doctorForm.last_name} onChange={handleChangeDoctor} name='last_name' variant='underlined' label='Last Name' />
                                            <Input value={doctorForm.father_name} onChange={handleChangeDoctor} name='father_name' variant='underlined' label='Father Name' />
                                            <Input value={String(doctorForm.phone_number)} onChange={handleChangeDoctor} name='phone_number' variant='underlined' label='Phone number' />
                                            <Input value={doctorForm.profile_picture} onChange={handleChangeDoctor} name='profile_picture' variant='underlined' label='Profile Picture' />
                                            <div className='flex gap-3 justify-end'>
                                                <Button size='lg' color='success' type='submit'>Add Doctor</Button>
                                                <AlertDialog.Cancel>
                                                    <Button size='lg' color='danger' type='button'>Close</Button>
                                                </AlertDialog.Cancel>
                                            </div>
                                        </form>
                                    </AlertDialog.Content>
                                </AlertDialog.Root>
                            </form>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AdminPanel;